import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Chip from '@material-ui/core/Chip';

const StationFilter = props => {
  const { t } = useTranslation(['search']);
  const tenant = useSelector(state => state.tenant);
  const startStation = useSelector(state => state.search.startStation);
  const endStation = useSelector(state => state.search.endStation);

  if (startStation.displayText) {
    return (
      <div>
        <div style={{ display: 'inline' }} {...props}>
          <Chip
            label={`${t('search:start-station-light')} : ${
              startStation.displayText
            }`}
            color="primary"
            variant="outlined"
          />
        </div>
        {tenant.oneWay ? (
          <div style={{ display: 'inline' }} {...props}>
            <Chip
              label={`${t('search:end-station-light')} : ${
                endStation.displayText
              }`}
              color="primary"
              variant="outlined"
            />
          </div>
        ) : null}
      </div>
    );
  } else {
    return null;
  }
};

export default StationFilter;
